<template>
  <div>
    <div class="pi-no-list-data" v-if="list.length > 0 && isMore">
      <div class="no-list-text">没有更多了哦</div>
    </div>
    <div class="pi-no-list-data no-list-icon-box" v-else-if="list.length == 0">
      <slot></slot>
      <div class="no-list-text">{{ text }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "pi-no-list-data",
  data() {
    return {};
  },
  props: {
    text: {
      type: String,
      default: "",
    },
    list: {
      type: Array,
      default: ()=>{
        return []
      },
    },
    isMore: {
      type: Boolean,
      default: true,
    },
  },
  methods: {},
};
</script>

<style lang="less">
.pi-no-list-data {
  text-align: center;

  img {
    width: 3.5rem;
    height: 3rem;
    display: inline-block;
  }
  .no-list-text {
    padding: 0.2rem;
    font-size: 0.28rem;
    line-height: 0.4rem;
    color: #999;
  }
}
.pi-no-list-data.no-list-icon-box {
  position: absolute;
  width: 100%;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -70%);
}
</style>
